export enum PaymentTypes {
  EWallet = 'E-Wallet',
  Fiat = 'Fiat currency',
}

export interface ETHPrice {
  USD: number;
  EUR: number;
}
